import React from 'react';
import { useHeaderTheme } from '../../theme';
import useStyles from './useStylesMenuButton';

export type MobileMenuButtonProps = {
  showMobileNav: boolean;
  toggleMobileNav(): void;
  testid?: string;
  left: boolean;
};

export const MobileMenuButton = ({
  showMobileNav,
  toggleMobileNav,
  testid = 'mobile-menu-button',
  left,
}: MobileMenuButtonProps) => {
  const theme = useHeaderTheme();
  const classes = useStyles({ showMobileNav, left, theme });

  return (
    <button
      className={classes.menuButton}
      onClick={toggleMobileNav}
      type="button"
      data-testid={testid}
    >
      <div className={classes.menuButtonLineTop} />
      <div className={classes.menuButtonLineMiddleLeft} />
      <div className={classes.menuButtonLineMiddleRight} />
      <div className={classes.menuButtonLineBottom} />
    </button>
  );
};

export default MobileMenuButton;
